import { render, staticRenderFns } from "./MenuFolder.vue?vue&type=template&id=5f3f8667&scoped=true&"
import script from "./MenuFolder.vue?vue&type=script&lang=js&"
export * from "./MenuFolder.vue?vue&type=script&lang=js&"
import style0 from "./MenuFolder.vue?vue&type=style&index=0&id=5f3f8667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3f8667",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
